/**
 * Supplier Purchase Review (Beta) Report
 *
 * Per-(FP, supplier, product) rollup of inventory purchases across the whole
 * network (Xero stock-order bills). Each supplier name is checked against the
 * master vendor list - "In Master?" = No flags a name to review. Use the
 * Suppliers multi-select to focus on specific suppliers. Category is matched
 * to Lightspeed by product name; rows that don't match show "(Unmatched)".
 */
import { Chip } from '@mui/material'
import BaseReportPage, { ColumnDef } from './BaseReportPage'

const columns: ColumnDef[] = [
  { key: 'fp_code', label: 'FP' },
  { key: 'fp_name', label: 'Franchise', align: 'left' },
  { key: 'region_code', label: 'Region', filterable: true },
  { key: 'supplier', label: 'Supplier', align: 'left' },
  {
    key: 'in_master',
    label: 'In Master?',
    type: 'boolean',
    align: 'center',
    filterable: true,
  },
  { key: 'description', label: 'Product', align: 'left' },
  { key: 'category', label: 'Category', filterable: true, mutedValues: ['(Unmatched)'] },
  { key: 'po_count', label: 'Orders', type: 'integer', align: 'right' },
  { key: 'total_qty', label: 'Total Qty', align: 'right' },
  { key: 'avg_unit', label: 'Avg Unit Cost', type: 'currency', align: 'right' },
  { key: 'total_cost', label: 'Total Cost', type: 'currency', align: 'right' },
  { key: 'last_purchase', label: 'Last Purchase', type: 'date' },
  {
    key: 'latest_bill_url',
    label: 'Latest Bill',
    link: { field: 'latest_bill_url', system: 'xero', text: 'View', showIcon: false },
  },
]

export default function SupplierPurchaseReviewReport() {
  return (
    <BaseReportPage
      reportType="supplier_purchase_review"
      title="Supplier Purchase Review"
      titleSuffix={<Chip size="small" color="warning" label="Beta" />}
      description="Inventory-supplier purchases per FP and product across the network, with supplier names checked against the master vendor list. Category is matched to Lightspeed by product name."
      filterConfig={{
        showFpSelector: true,
        showFpStatus: true,
        showCountry: true,
        showRegion: true,
        showSupplierMultiSelect: true,
        showDateRange: true,
        defaultDateRange: 'last_12_months',
        linkFpStatusToSearch: true,
      }}
      columns={columns}
      defaultSortColumn="total_cost"
      defaultSortDirection="desc"
    />
  )
}
